import { i18n } from "../../../i18n";
import { FeatureAttribute } from "../components/Attributes/FeatureAttributeField";
import { ConfigContainerChild, FilterItem } from "../types";

export const getFormattedAttributes = (
  data: FilterItem[],
  attributes: FeatureAttribute[],
  config: ConfigContainerChild,
): FeatureAttribute[] => {
  const showOtherItems = config?.options?.otherItems < data?.length;
  const otherIndex = config?.options?.otherItems + 1;
  const otherAttribute =
    showOtherItems && config?.children?.[otherIndex]
      ? attributes.find(({ name }) => name === config?.children?.[otherIndex]?.attributeName)
      : null;

  return otherAttribute
    ? [
        ...attributes,
        {
          ...otherAttribute,
          name: i18n.t("classification.other", { ns: "common" }),
          alias: i18n.t("classification.other", { ns: "common" }),
        },
      ]
    : attributes;
};
